'use client'

import Script from 'next/script'

interface GTMScriptProps {
  gtmId?: string
}

export default function GTM({ gtmId }: GTMScriptProps) {
  // 環境に応じたGTM IDの設定
  const finalGtmId =
    gtmId || (process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 'GTM-T9FLMGC' : 'GTM-NSMVZKZ')

  if (!finalGtmId) {
    return null
  }

  return (
    <>
      {/* Google Tag Manager */}
      <Script
        id='gtm-script'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),
                  dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${finalGtmId}');
          `,
        }}
      />
    </>
  )
}
